import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '@origin-digital/style-guide';

interface IProps {
  'data-testhook'?: string;
  className?: string;
  name?: string;
  type?: string;
  disabled?: boolean;
}

const defaultProps = {};

export class ButtonBase extends React.Component<IProps, {}> {
  public static defaultProps = defaultProps;

  public render() {
    return <button {...this.props} />;
  }
}

export default styled(ButtonBase)`
  appearance: none;
  background-color: ${(p) => p.theme.colors.red};
  border-radius: 0;
  border: none;
  box-sizing: border-box;
  color: ${(p) => p.theme.colors.white};
  font-family: ${(p) => p.theme.brandFont};
  cursor: pointer;
  display: block;
  transition: 300ms all;
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.5;
  padding: 12px 30px;
  text-decoration: none;
  width: 100%;

  &:hover,
  &:hover:not(:disabled) {
    background-color: ${(p) => p.theme.colors.redDark};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 4px ${(p) => p.theme.colors.redOutline};
  }

  &:disabled {
    color: ${(p) => p.theme.colors.white};
    background-color: ${(p) => p.theme.colors.redLight};
    cursor: default;
  }
`;
